export default __webpack_public_path__ + "static/media/supermarket.02478cdc.png";